module.exports = __webpack_public_path__ + "img/pending_actionsmeds.40b620a2.png";